<template>
  <GestionReporteAcumulado />
</template>
<script>
import GestionReporteAcumulado from "./components/GestionReporteAcumulado";
export default {
  components: { GestionReporteAcumulado },
};
</script>